module.exports = __webpack_public_path__ + "img/gamesdk15.9cd017c.png";